import React from 'react';
import { Modal, Button, Row, Col } from 'react-bootstrap';

const RegistrationDetailModal = ({ 
  show, 
  onHide, 
  data, 
  loading = false,
  showEditButton = false,
  onEdit = null,
  dialogClassName = ''
}) => {
  
  const formatPhoneNumber = (phone) => {
    if (!phone) return 'N/A';
    return phone;
  };

  const formatDate = (date) => {
    if (!date) return 'N/A';
    const d = new Date(date);
    return d.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
  };

  const calculateAge = (dob) => {
    if (!dob) return 'N/A';
    const birthDate = new Date(dob);
    const today = new Date();
    const age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      return age - 1;
    }
    return age;
  };

  return (
    <>
      <style>{`
        .detail-modal-section {
          background: #ffffff;
          border-radius: 6px;
          padding: 14px 16px;
          margin-bottom: 12px;
          border: 1px solid #e5e7eb;
          box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
        }
        .detail-modal-section h5 {
          color: #374151;
          font-weight: 600;
          margin-bottom: 12px;
          display: flex;
          align-items: center;
          font-size: 0.95rem;
          padding-bottom: 8px;
          border-bottom: 1px solid #f3f4f6;
        }
        .detail-modal-section h5 i {
          margin-right: 8px;
          background: #f3f4f6;
          color: #6b7280;
          padding: 5px;
          border-radius: 4px;
          font-size: 18px;
        }
        .detail-modal-section p {
          color: #4b5563;
          margin-bottom: 6px;
          font-size: 0.875rem;
          line-height: 1.5;
        }
        .detail-modal-section strong {
          color: #1f2937;
          font-weight: 600;
          font-size: 0.875rem;
        }
      `}</style>
      <Modal show={show} onHide={onHide} size="xl" dialogClassName={dialogClassName}>
        <Modal.Header closeButton style={{ background: '#ffffff', borderBottom: '1px solid #e5e7eb', padding: '14px 18px' }}>
          <Modal.Title style={{ fontSize: '1.1rem', fontWeight: '700', color: '#111827', display: 'flex', alignItems: 'center', gap: '8px' }}>
            <i className="material-symbols-outlined" style={{ fontSize: '22px', color: '#6366f1' }}>description</i>
            Child Registration Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ background: '#f8f9fa', padding: '16px', maxHeight: '70vh', overflowY: 'auto' }}>
          {loading ? (
            <div style={{ textAlign: 'center', padding: '60px 40px', color: '#6b7280' }}>
              <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem', marginBottom: '20px' }}>
                <span className="visually-hidden">Loading...</span>
              </div>
              <p style={{ fontSize: '16px', fontWeight: '500' }}>
                Loading registration details...
              </p>
            </div>
          ) : data ? (
            <div>
              {/* Child Information */}
              <div className="detail-modal-section">
                <h5>
                  <i className="material-symbols-outlined">child_care</i>
                  Child Information
                </h5>
                <Row>
                  <Col md={6}>
                    <p><strong>Full Name:</strong> {data.child_first_name || 'N/A'} {data.child_last_name || ''}</p>
                    <p><strong>Date of Birth:</strong> {formatDate(data.child_dob || data.child_date_of_birth)}</p>
                    <p><strong>Age:</strong> {data.child_age || calculateAge(data.child_dob || data.child_date_of_birth) || 'N/A'} years</p>
                    {(() => {
                      const genderValue = data.child_gender ?? data.user_details?.user_setting?.gender;
                      const shouldRenderGender =
                        genderValue !== null &&
                        genderValue !== undefined &&
                        genderValue !== '' &&
                        genderValue !== 0 &&
                        genderValue !== '0';

                      return shouldRenderGender ? (
                        <p><strong>Gender:</strong> {genderValue}</p>
                      ) : null;
                    })()}
                    {(data.child_email || data.user_details?.email) && (
                      <p><strong>Email:</strong> {data.child_email || data.user_details?.email}</p>
                    )}
                  </Col>
                  <Col md={6}>
                    {(data.user_details?.user_setting?.address || data.child_home_address || data.child_address || data.child_city || data.child_postal_code) && (
                      <>
                        <p><strong>Address:</strong> {data.user_details?.user_setting?.address || data.child_home_address || data.child_address || 'N/A'}</p>
                        <p><strong>City:</strong> {data.child_city || 'N/A'}</p>
                        {(data.child_province || data.child_state) && (
                          <p><strong>Province/State:</strong> {data.child_province || data.child_state}</p>
                        )}
                        <p><strong>Postal/ZIP Code:</strong> {data.child_postal_code || 'N/A'}</p>
                      </>
                    )}
                  </Col>
                </Row>
              </div>

              {/* Parent/Guardian 1 (Mother) */}
              {(data.mother_name || data.parent1_first_name) && (
                <div className="detail-modal-section">
                  <h5>
                    <i className="material-symbols-outlined">person</i>
                    {data.mother_name ? 'Mother' : 'Parent/Guardian 1'}
                  </h5>
                  <Row>
                    <Col md={6}>
                      <p><strong>Name:</strong> {data.mother_name || `${data.parent1_first_name || ''} ${data.parent1_last_name || ''}`.trim()}</p>
                      <p><strong>Relation:</strong> {data.parent1_relation || 'Mother'}</p>
                      <p><strong>Home Phone:</strong> {formatPhoneNumber(data.mother_home_phone || data.parent1_phone)}</p>
                      <p><strong>Cell:</strong> {formatPhoneNumber(data.mother_cell || data.parent1_cell)}</p>
                    </Col>
                    <Col md={6}>
                      <p><strong>Email:</strong> {data.mother_email || data.parent1_email || 'N/A'}</p>
                      <p><strong>Address:</strong> {
                        data.mother_home_address ||
                        data.parent1_home_address ||
                        data.parent1_address ||
                        data.father_home_address ||
                        data.parent2_home_address ||
                        data.parent2_address ||
                        'N/A'
                      }</p>
                      <p><strong>City:</strong> {data.mother_city || data.parent1_city || 'N/A'}</p>
                      {(data.mother_province || data.mother_state || data.parent1_province || data.parent1_state) && (
                        <p><strong>Province/State:</strong> {data.mother_province || data.mother_state || data.parent1_province || data.parent1_state}</p>
                      )}
                      <p><strong>Postal/ZIP Code:</strong> {data.mother_postal_code || data.parent1_zip || 'N/A'}</p>
                      {(data.mother_work_phone || data.parent1_work_phone) && (
                        <p><strong>Work Phone:</strong> {formatPhoneNumber(data.mother_work_phone || data.parent1_work_phone)}</p>
                      )}
                    </Col>
                  </Row>
                </div>
              )}

              {/* Parent/Guardian 2 (Father) */}
              {(data.father_name || data.parent2_first_name) && (
                <div className="detail-modal-section">
                  <h5>
                    <i className="material-symbols-outlined">person</i>
                    {data.father_name ? 'Father' : 'Parent/Guardian 2'}
                  </h5>
                  <Row>
                    <Col md={6}>
                      <p><strong>Name:</strong> {data.father_name || `${data.parent2_first_name || ''} ${data.parent2_last_name || ''}`.trim()}</p>
                      <p><strong>Relation:</strong> {data.parent2_relation || 'Father'}</p>
                      <p><strong>Home Phone:</strong> {formatPhoneNumber(data.father_home_phone || data.parent2_phone)}</p>
                      <p><strong>Cell:</strong> {formatPhoneNumber(data.father_cell || data.parent2_cell)}</p>
                    </Col>
                    <Col md={6}>
                      <p><strong>Email:</strong> {data.father_email || data.parent2_email || 'N/A'}</p>
                      {!data.same_address && (data.father_home_address || data.parent2_address) && (
                        <>
                          <p><strong>Address:</strong> {data.father_home_address || data.parent2_address}</p>
                          <p><strong>City:</strong> {data.father_city || data.parent2_city}</p>
                          {(data.father_province || data.father_state || data.parent2_province || data.parent2_state) && (
                            <p><strong>Province/State:</strong> {data.father_province || data.father_state || data.parent2_province || data.parent2_state}</p>
                          )}
                          <p><strong>Postal/ZIP Code:</strong> {data.father_postal_code || data.parent2_zip}</p>
                        </>
                      )}
                      {data.same_address && (
                        <p><em>Same address as {data.mother_name ? 'Mother' : 'Parent/Guardian 1'}</em></p>
                      )}
                      {(data.father_work_phone || data.parent2_work_phone) && (
                        <p><strong>Work Phone:</strong> {formatPhoneNumber(data.father_work_phone || data.parent2_work_phone)}</p>
                      )}
                    </Col>
                  </Row>
                </div>
              )}

              {/* Emergency Contact */}
              {data.emergency_contact_name && (
                <div className="detail-modal-section">
                  <h5>
                    <i className="material-symbols-outlined">emergency</i>
                    Emergency Contact
                  </h5>
                  <Row>
                    <Col md={6}>
                      <p><strong>Name:</strong> {data.emergency_contact_name}</p>
                      <p><strong>Relation:</strong> {data.emergency_contact_relationship || data.emergency_contact_relation || 'N/A'}</p>
                      <p><strong>Home Phone:</strong> {formatPhoneNumber(data.emergency_contact_phone)}</p>
                      <p><strong>Cell:</strong> {formatPhoneNumber(data.emergency_contact_cell)}</p>
                    </Col>
                    <Col md={6}>
                      <p><strong>Email:</strong> {data.emergency_contact_email || 'N/A'}</p>
                      {(data.emergency_contact_home_address || data.emergency_contact_address) && (
                        <>
                          <p><strong>Home Address:</strong> {data.emergency_contact_home_address || data.emergency_contact_address}</p>
                          <p><strong>City:</strong> {data.emergency_contact_city}</p>
                          {(data.emergency_contact_province || data.emergency_contact_state) && (
                            <p><strong>Province/State:</strong> {data.emergency_contact_province || data.emergency_contact_state}</p>
                          )}
                          <p><strong>Postal/ZIP Code:</strong> {data.emergency_contact_postal_code}</p>
                        </>
                      )}
                      {data.emergency_contact_work_phone && (
                        <p><strong>Work Phone:</strong> {formatPhoneNumber(data.emergency_contact_work_phone)}</p>
                      )}
                      {data.emergency_contact_work_address && (
                        <p><strong>Work Address:</strong> {data.emergency_contact_work_address}</p>
                      )}
                    </Col>
                  </Row>
                </div>
              )}

              {/* Authorized Pickup Persons */}
              {(data.pickup1_name || data.pickup2_name || data.pickup3_name || data.pickup4_name ||
                data.pickup_person1_name || data.pickup_person2_name || data.pickup_person3_name || data.pickup_person4_name) && (
                <div className="detail-modal-section">
                  <h5>
                    <i className="material-symbols-outlined">person_check</i>
                    Authorized Pick-Up List
                  </h5>
                  {[1, 2, 3, 4].map(num => {
                    const name = data[`pickup${num}_name`] || data[`pickup_person${num}_name`];
                    if (!name) return null;
                    
                    return (
                      <div key={num} style={{ background: '#f9fafb', padding: '10px 12px', borderRadius: '4px', marginBottom: '10px', border: '1px solid #e5e7eb' }}>
                        <p className="mb-1" style={{ fontSize: '0.875rem' }}><strong>Name:</strong> {name}</p>
                        {(data[`pickup${num}_relation`] || data[`pickup_person${num}_relation`]) && (
                          <p className="mb-1" style={{ fontSize: '0.875rem' }}><strong>Relation:</strong> {data[`pickup${num}_relation`] || data[`pickup_person${num}_relation`]}</p>
                        )}
                        <Row>
                          <Col md={6}>
                            <p className="mb-1"><strong>Phone:</strong> {formatPhoneNumber(data[`pickup${num}_phone`] || data[`pickup_person${num}_phone`])}</p>
                            {(data[`pickup${num}_cell`] || data[`pickup_person${num}_cell`]) && (
                              <p className="mb-1"><strong>Cell:</strong> {formatPhoneNumber(data[`pickup${num}_cell`] || data[`pickup_person${num}_cell`])}</p>
                            )}
                          </Col>
                          <Col md={6}>
                            {(data[`pickup${num}_address`] || data[`pickup_person${num}_address`]) && (
                              <>
                                <p className="mb-1"><strong>Address:</strong> {data[`pickup${num}_address`] || data[`pickup_person${num}_address`]}</p>
                                <p className="mb-1"><strong>City:</strong> {data[`pickup${num}_city`] || data[`pickup_person${num}_city`]} | <strong>Postal/ZIP Code:</strong> {data[`pickup${num}_zip`] || data[`pickup_person${num}_postal_code`]}</p>
                              </>
                            )}
                          </Col>
                        </Row>
                      </div>
                    );
                  })}
                </div>
              )}

              {/* Arrival and Departure */}
              {(data.dropoff_time || data.drop_off_time || data.pickup_time || data.pick_up_time || 
                data.start_date || data.withdrawal_date || data.parent_guardian_signature || 
                data.parent_signature || data.executive_director_signature) && (
                <div className="detail-modal-section">
                  <h5>
                    <i className="material-symbols-outlined">schedule</i>
                    Arrival and Departure
                  </h5>
                  <Row>
                    <Col md={6}>
                      {(data.dropoff_time || data.drop_off_time) && (
                        <p><strong>Drop-off Time:</strong> {data.dropoff_time || data.drop_off_time}</p>
                      )}
                      {(data.pickup_time || data.pick_up_time) && (
                        <p><strong>Pick-up Time:</strong> {data.pickup_time || data.pick_up_time}</p>
                      )}
                    </Col>
                    <Col md={6}>
                      {data.start_date && (
                        <p><strong>Start Date:</strong> {formatDate(data.start_date)}</p>
                      )}
                      {data.withdrawal_date && (
                        <p><strong>Withdrawal Date:</strong> {formatDate(data.withdrawal_date)}</p>
                      )}
                    </Col>
                  </Row>
                  {(data.parent_guardian_signature || data.parent_signature || data.executive_director_signature) && (
                    <div className="mt-3">
                      <Row>
                        {(data.parent_guardian_signature || data.parent_signature) && (
                          <Col md={6}>
                            <p className="mb-2"><strong>Parent/Guardian Signature:</strong></p>
                            <div className="border rounded p-2 bg-light" style={{ display: 'inline-block', maxWidth: '300px' }}>
                              <img 
                                src={data.parent_guardian_signature || data.parent_signature} 
                                alt="Parent/Guardian Signature" 
                                style={{ maxWidth: '100%', maxHeight: '120px', display: 'block' }}
                              />
                            </div>
                          </Col>
                        )}
                        {data.executive_director_signature && (
                          <Col md={6}>
                            <p className="mb-2"><strong>Executive Director Signature:</strong></p>
                            <div className="border rounded p-2 bg-light" style={{ display: 'inline-block', maxWidth: '300px' }}>
                              <img 
                                src={data.executive_director_signature} 
                                alt="Executive Director Signature" 
                                style={{ maxWidth: '100%', maxHeight: '120px', display: 'block' }}
                              />
                            </div>
                          </Col>
                        )}
                      </Row>
                    </div>
                  )}
                </div>
              )}

              {/* Emergency Medical Authorization */}
              {(data.family_physician_name || data.pediatrician_name || data.physician_phone_number || 
                data.pediatrician_phone || data.current_medications || data.medications || 
                data.allergies_health_info || data.allergies || data.emergency_auth_signature) && (
                <div className="detail-modal-section">
                  <h5>
                    <i className="material-symbols-outlined">medical_services</i>
                    Emergency Medical Authorization
                  </h5>
                  <Row>
                    <Col md={6}>
                      <p><strong>Family Physician:</strong> {data.family_physician_name || data.pediatrician_name || 'N/A'}</p>
                      <p><strong>Physician Phone:</strong> {formatPhoneNumber(data.physician_phone_number || data.pediatrician_phone)}</p>
                      {data.physician_address && (
                        <p><strong>Physician Address:</strong> {data.physician_address}</p>
                      )}
                    </Col>
                    <Col md={6}>
                      <p><strong>Current Medications:</strong> {data.current_medications || data.medications || 'None reported'}</p>
                      <p><strong>Allergies/Health Info:</strong> {data.allergies_health_info || data.allergies || 'None reported'}</p>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      {(data.sleep_time_night || data.sleep_time) && (
                        <p><strong>Sleep Time (Night):</strong> {data.sleep_time_night || data.sleep_time}</p>
                      )}
                      {data.child_favourite_activity && (
                        <p><strong>Child's Favourite Activity:</strong> {data.child_favourite_activity}</p>
                      )}
                    </Col>
                    <Col md={6}>
                      {(data.wake_time_morning || data.wake_time) && (
                        <p><strong>Wake Time (Morning):</strong> {data.wake_time_morning || data.wake_time}</p>
                      )}
                    </Col>
                  </Row>
                  {data.emergency_auth_signature && (
                    <div className="mt-3">
                      <p className="mb-2"><strong>Emergency Authorization Signature:</strong></p>
                      <div className="border rounded p-2 bg-light" style={{ display: 'inline-block', maxWidth: '300px' }}>
                        <img 
                          src={data.emergency_auth_signature} 
                          alt="Emergency Auth Signature" 
                          style={{ maxWidth: '100%', maxHeight: '120px', display: 'block' }}
                        />
                      </div>
                      {data.emergency_auth_date && (
                        <div className="mt-2">
                          <small className="text-muted">Date: {formatDate(data.emergency_auth_date)}</small>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )}

              {/* Child Information Page */}
              {(data.agency_involvement || data.child_related_agencies_involvement || 
                data.vision_history || data.vision_history_glasses || 
                data.hearing_concerns || data.hearing_concerns_audiologist || 
                data.diagnoses || data.diagnoses_adhd_delays || 
                data.communicable_disease || data.communicable_disease_history || 
                data.eating_concerns || data.eating_appetite_concerns || 
                data.developmental_concerns || 
                data.pets_at_home || 
                data.siblings_info || data.siblings_family_info || 
                data.favourite_toy || data.child_favourite_toy_activity) && (
                <div className="detail-modal-section">
                  <h5>
                    <i className="material-symbols-outlined">description</i>
                    Child Information Page
                  </h5>
                  {(data.agency_involvement || data.child_related_agencies_involvement) && (
                    <p><strong>Involvement with Child-Related Agencies:</strong><br />{data.child_related_agencies_involvement || data.agency_involvement}</p>
                  )}
                  {(data.vision_history || data.vision_history_glasses) && (
                    <p><strong>Vision History / Glasses Usage:</strong><br />{data.vision_history_glasses || data.vision_history}</p>
                  )}
                  {(data.hearing_concerns || data.hearing_concerns_audiologist) && (
                    <p><strong>Hearing Concerns / Audiologist Visits:</strong><br />{data.hearing_concerns_audiologist || data.hearing_concerns}</p>
                  )}
                  {(data.diagnoses || data.diagnoses_adhd_delays) && (
                    <p><strong>Any Diagnoses (e.g., ADHD, delays):</strong><br />{data.diagnoses_adhd_delays || data.diagnoses}</p>
                  )}
                  {(data.communicable_disease || data.communicable_disease_history) && (
                    <p><strong>Communicable Disease History:</strong><br />{data.communicable_disease_history || data.communicable_disease}</p>
                  )}
                  {(data.eating_concerns || data.eating_appetite_concerns) && (
                    <p><strong>Eating/Appetite Concerns:</strong><br />{data.eating_appetite_concerns || data.eating_concerns}</p>
                  )}
                  {data.developmental_concerns && (
                    <p><strong>Developmental Concerns:</strong><br />{data.developmental_concerns}</p>
                  )}
                  {data.pets_at_home && (
                    <p><strong>Pets at Home:</strong><br />{data.pets_at_home}</p>
                  )}
                  {(data.siblings_info || data.siblings_family_info) && (
                    <p><strong>Siblings / Family Info:</strong><br />{data.siblings_family_info || data.siblings_info}</p>
                  )}
                  {(data.favourite_toy || data.child_favourite_toy_activity) && (
                    <p><strong>Child's Favourite Toy or Activity:</strong><br />{data.child_favourite_toy_activity || data.favourite_toy}</p>
                  )}
                </div>
              )}

              {/* Enrollment Information */}
              {data.enrollment_date && (
                <div className="detail-modal-section">
                  <h5>
                    <i className="material-symbols-outlined">event</i>
                    Enrollment Information
                  </h5>
                  <p><strong>Enrollment Date:</strong> {formatDate(data.enrollment_date)}</p>
                </div>
              )}

              {/* Media Release Waiver */}
              {(data.media_release_agree !== undefined || data.media_release_disagree !== undefined || 
                data.media_release_signature || data.media_release_signature_agree || data.media_release_signature_disagree) && (
                <div className="detail-modal-section">
                  <h5>
                    <i className="material-symbols-outlined">photo_camera</i>
                    Media Release Waiver
                  </h5>
                  {(data.media_release_agree === 1 || data.media_release_agree === '1' || data.media_release_agree === true) && (
                    <div style={{ background: '#ecfdf5', padding: '10px 12px', borderRadius: '4px', marginBottom: '10px', border: '1px solid #d1fae5' }}>
                      <p className="mb-1" style={{ fontSize: '0.875rem' }}><strong>Status:</strong> <span style={{ color: '#059669' }}>AGREED</span></p>
                      <p className="mb-1" style={{ fontSize: '0.875rem' }}><strong>Child's Name:</strong> {data.media_release_child_name_agree || data.media_release_child_name}</p>
                      <p className="mb-0" style={{ fontSize: '0.875rem' }}><strong>Parent's Name:</strong> {data.media_release_parent_name_agree || data.media_release_parent_name}</p>
                    </div>
                  )}
                  {(data.media_release_agree === 0 || data.media_release_agree === '0' || data.media_release_agree === false || data.media_release_disagree) && (
                    <div style={{ background: '#fef2f2', padding: '10px 12px', borderRadius: '4px', marginBottom: '10px', border: '1px solid #fecaca' }}>
                      <p className="mb-1" style={{ fontSize: '0.875rem' }}><strong>Status:</strong> <span style={{ color: '#dc2626' }}>DISAGREED</span></p>
                      <p className="mb-1" style={{ fontSize: '0.875rem' }}><strong>Child's Name:</strong> {data.media_release_child_name_disagree || data.media_release_child_name}</p>
                      <p className="mb-0" style={{ fontSize: '0.875rem' }}><strong>Parent's Name:</strong> {data.media_release_parent_name_disagree || data.media_release_parent_name}</p>
                    </div>
                  )}
                  {(data.media_release_signature || data.media_release_signature_agree || data.media_release_signature_disagree) && (
                    <div className="mt-3">
                      <p className="mb-2"><strong>Parent Signature:</strong></p>
                      <div className="border rounded p-2 bg-light" style={{ display: 'inline-block', maxWidth: '300px' }}>
                        <img 
                          src={data.media_release_signature_agree || data.media_release_signature_disagree || data.media_release_signature} 
                          alt="Media Release Signature" 
                          style={{ maxWidth: '100%', maxHeight: '120px', display: 'block' }}
                        />
                      </div>
                      {(data.media_release_date || data.media_release_date_agree || data.media_release_date_disagree) && (
                        <div className="mt-2">
                          <small className="text-muted">Date: {formatDate(data.media_release_date_agree || data.media_release_date_disagree || data.media_release_date)}</small>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )}

              {/* Off-Site Permission Form */}
              {(data.offsite_permission || data.offsite_parent_name || data.offsite_child_name || 
                data.offsite_permission_parent_name || data.offsite_permission_child_name || data.offsite_signature) && (
                <div className="detail-modal-section">
                  <h5>
                    <i className="material-symbols-outlined">directions_walk</i>
                    Off-Site Permission Form
                  </h5>
                  {(data.offsite_parent_name || data.offsite_permission_parent_name) && (
                    <p><strong>Parent Name:</strong> {data.offsite_permission_parent_name || data.offsite_parent_name}</p>
                  )}
                  {(data.offsite_child_name || data.offsite_permission_child_name) && (
                    <p><strong>Child Name:</strong> {data.offsite_permission_child_name || data.offsite_child_name}</p>
                  )}
                  {(data.offsite_permission_date || data.offsite_date) && (
                    <p><strong>Date:</strong> {formatDate(data.offsite_permission_date || data.offsite_date)}</p>
                  )}
                  {(data.offsite_signature || data.offsite_permission_signature) && (
                    <div className="mt-3">
                      <p className="mb-2"><strong>Signature:</strong></p>
                      <div className="border rounded p-2 bg-light" style={{ display: 'inline-block', maxWidth: '300px' }}>
                        <img 
                          src={data.offsite_permission_signature || data.offsite_signature} 
                          alt="Off-Site Permission Signature" 
                          style={{ maxWidth: '100%', maxHeight: '120px', display: 'block' }}
                        />
                      </div>
                    </div>
                  )}
                </div>
              )}

              {/* Contract Terms and Conditions */}
              {(data.contract_terms_initials || data.contract_parent_name || data.contract_parent_print_name || 
                data.contract_parent_signature || data.contract_signature || 
                data.financially_responsible_name || data.financially_responsible_signature ||
                data.contract_clause1_initial || data.contract_clause2_initial || data.contract_clause3_initial ||
                data.contract_clause4_initial || data.contract_clause5_initial || data.contract_clause6_initial ||
                data.contract_parent_date || data.contract_date) && (
                <div className="detail-modal-section">
                  <h5>
                    <i className="material-symbols-outlined">contract</i>
                    Contract Terms and Conditions
                  </h5>
                  
                  {/* Individual Contract Clauses */}
                  {(data.contract_clause1_initial || data.contract_clause2_initial || data.contract_clause3_initial || 
                    data.contract_clause4_initial || data.contract_clause5_initial || data.contract_clause6_initial ||
                    data.contract_clause7_initial || data.contract_clause8_initial || data.contract_clause9_initial ||
                    data.contract_clause10_initial || data.contract_clause11_initial || data.contract_clause12_initial ||
                    data.contract_clause13_initial || data.contract_terms_initials) && (
                    <div className="contract-clauses mb-3">
                      <p className="mb-2"><strong>Contract Clauses:</strong></p>
                      {[
                        { num: 1, text: "I have read and agree to the terms and conditions outlined in this contract", initial: data.contract_clause1_initial },
                        { num: 2, text: "I understand payment is due weekly in advance", initial: data.contract_clause2_initial },
                        { num: 3, text: "I understand that there will be a late fee charged for payments not received by Friday", initial: data.contract_clause3_initial },
                        { num: 4, text: "I understand that returned checks will incur a $25 fee", initial: data.contract_clause4_initial },
                        { num: 5, text: "I understand that two weeks notice is required for withdrawal", initial: data.contract_clause5_initial },
                        { num: 6, text: "I agree to provide all required medical and emergency information", initial: data.contract_clause6_initial },
                        { num: 7, text: "I authorize emergency medical treatment if necessary", initial: data.contract_clause7_initial },
                        { num: 8, text: "I understand the center's hours and holiday schedule", initial: data.contract_clause8_initial },
                        { num: 9, text: "I agree to follow the center's sick child policy", initial: data.contract_clause9_initial },
                        { num: 10, text: "I understand the diaper and supply requirements", initial: data.contract_clause10_initial },
                        { num: 11, text: "I agree to the center's discipline and behavior management policies", initial: data.contract_clause11_initial },
                        { num: 12, text: "I understand the center reserves the right to dismiss enrollment", initial: data.contract_clause12_initial },
                        { num: 13, text: "I acknowledge receiving a copy of the parent handbook", initial: data.contract_clause13_initial }
                      ].map((clause, idx) => (
                        <div key={idx} style={{ 
                          display: 'flex', 
                          alignItems: 'center', 
                          padding: '12px 0',
                          borderBottom: idx < 12 ? '1px solid #f3f4f6' : 'none'
                        }}>
                          <div style={{ 
                            minWidth: '80px',
                            width: '80px',
                            height: '60px',
                            border: '2px solid #059669',
                            borderRadius: '6px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginRight: '16px',
                            flexShrink: 0,
                            background: clause.initial ? '#ecfdf5' : '#f9fafb',
                            padding: '4px'
                          }}>
                            {clause.initial && (
                              clause.initial.startsWith('data:image') || clause.initial.startsWith('http') ? (
                                <img 
                                  src={clause.initial} 
                                  alt={`Initial ${clause.num}`} 
                                  style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
                                />
                              ) : (
                                <span style={{ color: '#059669', fontWeight: 'bold', fontSize: '24px' }}>✓</span>
                              )
                            )}
                          </div>
                          <span style={{ fontSize: '0.875rem', lineHeight: '1.5', flex: 1 }}>
                            <strong>{clause.num}.</strong> {clause.text}
                          </span>
                        </div>
                      ))}
                    </div>
                  )}

                  {/* Parent/Guardian Signature */}
                  <div className="mt-3 pt-3" style={{ borderTop: '1px solid #e5e7eb' }}>
                    <p className="mb-2"><strong>Parent/Guardian Agreement:</strong></p>
                    {(data.contract_parent_print_name || data.contract_parent_name) && (
                      <p><strong>Print Name:</strong> {data.contract_parent_print_name || data.contract_parent_name}</p>
                    )}
                    {(data.contract_parent_date || data.contract_date) && (
                      <p><strong>Date:</strong> {formatDate(data.contract_parent_date || data.contract_date)}</p>
                    )}
                    {(data.contract_parent_signature || data.contract_signature) && (
                      <div className="mt-2">
                        <p className="mb-2"><strong>Signature:</strong></p>
                        <div className="border rounded p-2 bg-light" style={{ display: 'inline-block', maxWidth: '300px' }}>
                          <img 
                            src={data.contract_parent_signature || data.contract_signature} 
                            alt="Contract Signature" 
                            style={{ maxWidth: '100%', maxHeight: '120px', display: 'block' }}
                          />
                        </div>
                      </div>
                    )}
                    {!data.contract_parent_print_name && !data.contract_parent_name && !data.contract_parent_date && !data.contract_date && !data.contract_parent_signature && !data.contract_signature && (
                      <p className="text-muted" style={{ fontSize: '0.875rem' }}>No parent/guardian signature recorded</p>
                    )}
                  </div>

                  {/* Financially Responsible Party */}
                  {(data.financially_responsible_name || data.financially_responsible_signature || 
                    data.financially_responsible_agency || data.financially_responsible_date) && (
                    <div className="mt-3 pt-3" style={{ borderTop: '1px solid #e5e7eb' }}>
                      <p className="mb-2"><strong>Financially Responsible Party:</strong></p>
                      {data.financially_responsible_name && (
                        <p><strong>Print Name:</strong> {data.financially_responsible_name}</p>
                      )}
                      {data.financially_responsible_agency && (
                        <p><strong>Agency:</strong> {data.financially_responsible_agency}</p>
                      )}
                      {data.financially_responsible_date && (
                        <p><strong>Date:</strong> {formatDate(data.financially_responsible_date)}</p>
                      )}
                      {data.financially_responsible_signature && (
                        <div className="mt-2">
                          <p className="mb-2"><strong>Signature:</strong></p>
                          <div className="border rounded p-2 bg-light" style={{ display: 'inline-block', maxWidth: '300px' }}>
                            <img 
                              src={data.financially_responsible_signature} 
                              alt="Financially Responsible Signature" 
                              style={{ maxWidth: '100%', maxHeight: '120px', display: 'block' }}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )}

              {/* Registration Checklist */}
              {(data.checklist_submitted || data.checklist_parent_signature || data.checklist_staff_signature ||
                data.checklist_registration_form || data.checklist_emergency_form) && (
                <div className="detail-modal-section">
                  <h5>
                    <i className="material-symbols-outlined">checklist</i>
                    Registration Checklist
                  </h5>
                  <p className="mb-3"><strong>Required Documents Submitted:</strong></p>
                  
                  {/* Checklist Items with Checkboxes */}
                  <Row>
                    {[
                      { label: 'Registration Form', field: 'checklist_registration_form' },
                      { label: 'Emergency Form', field: 'checklist_emergency_form' },
                      { label: 'Health Forms', field: 'checklist_health_forms' },
                      { label: 'Birth Certificate', field: 'checklist_birth_certificate' },
                      { label: 'Parent Handbook', field: 'checklist_parent_handbook' },
                      { label: 'Waivers', field: 'checklist_waivers' },
                      { label: 'Child Info Page', field: 'checklist_child_info_page' },
                      { label: 'Signed Contract', field: 'checklist_signed_contract' },
                      { label: 'Off-Site Permission', field: 'checklist_offsite_permission' },
                      { label: 'Medical Reports', field: 'checklist_medical_reports' },
                      { label: 'Pre-Authorized Debit', field: 'checklist_pre_authorized_debit' },
                      { label: 'All About Me', field: 'checklist_all_about_me' },
                      { label: 'Meal Waiver', field: 'checklist_meal_waiver' }
                    ].map((item, idx) => (
                      <Col md={6} key={idx} className="mb-2">
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <input 
                            type="checkbox" 
                            checked={data[item.field] === 1 || data[item.field] === '1' || data[item.field] === true}
                            readOnly
                            style={{ 
                              marginRight: '8px',
                              width: '18px',
                              height: '18px',
                              cursor: 'default',
                              accentColor: '#059669'
                            }}
                          />
                          <label style={{ marginBottom: 0, fontSize: '0.875rem', cursor: 'default' }}>
                            {item.label}
                          </label>
                        </div>
                      </Col>
                    ))}
                  </Row>

                  {/* Signatures Section */}
                  <Row className="mt-4 pt-3" style={{ borderTop: '1px solid #e5e7eb' }}>
                    <Col md={6}>
                      {data.checklist_parent_date && (
                        <p><strong>Parent Date:</strong> {formatDate(data.checklist_parent_date)}</p>
                      )}
                      {data.checklist_parent_signature && (
                        <div className="mt-2">
                          <p className="mb-2"><strong>Parent Signature:</strong></p>
                          <div className="border rounded p-2 bg-light" style={{ display: 'inline-block', maxWidth: '250px' }}>
                            <img 
                              src={data.checklist_parent_signature} 
                              alt="Parent Checklist Signature" 
                              style={{ maxWidth: '100%', maxHeight: '100px', display: 'block' }}
                            />
                          </div>
                        </div>
                      )}
                    </Col>
                    <Col md={6}>
                      {data.checklist_staff_signature && (
                        <>
                          <p><strong>Staff Witness Date:</strong> {formatDate(data.checklist_staff_date)}</p>
                          <div className="mt-2">
                            <p className="mb-2"><strong>Staff Witness Signature:</strong></p>
                            <div className="border rounded p-2 bg-light" style={{ display: 'inline-block', maxWidth: '250px' }}>
                              <img 
                                src={data.checklist_staff_signature} 
                                alt="Staff Witness Signature" 
                                style={{ maxWidth: '100%', maxHeight: '100px', display: 'block' }}
                              />
                            </div>
                          </div>
                        </>
                      )}
                    </Col>
                  </Row>
                </div>
              )}
            </div>
          ) : (
            <div style={{ textAlign: 'center', padding: '40px', color: '#6b7280' }}>
              <i className="ri-file-list-line" style={{ fontSize: '48px', opacity: 0.3 }}></i>
              <p style={{ marginTop: '16px', fontSize: '14px' }}>
                No registration data available
              </p>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer style={{ background: '#f9fafb', borderTop: '1px solid #e5e7eb' }}>
          <Button 
            variant="secondary"
            style={{ padding: '8px 20px', borderRadius: '6px', fontWeight: '500' }}
            onClick={onHide}
          >
            <i className="material-symbols-outlined me-1" style={{ fontSize: '18px', verticalAlign: 'middle' }}>close</i>
            Close
          </Button>
          {showEditButton && data && onEdit && (
            <Button 
              variant="primary"
              style={{ padding: '8px 20px', borderRadius: '6px', fontWeight: '500' }}
              onClick={() => {
                onHide();
                onEdit(data.id);
              }}
            >
              <i className="material-symbols-outlined me-1" style={{ fontSize: '18px', verticalAlign: 'middle' }}>edit</i>
              Edit Registration
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default RegistrationDetailModal;
